import type { AxiosError } from "axios"

/** Extract a human-readable API error message from axios/backend responses. */
export const getLearnerApiErrorMessage = (
  error: unknown,
  fallback = "Something went wrong. Please try again."
): string => {
  const axiosError = error as AxiosError<{ message?: string; detail?: string }>
  const data = axiosError?.response?.data

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message
  }
  if (typeof data?.detail === "string" && data.detail.trim()) {
    return data.detail
  }
  if (axiosError?.message === "Network Error") {
    return "Unable to reach the server. Check your connection and try again."
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message
  }
  return fallback
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidEmail = (email: string): boolean =>
  EMAIL_PATTERN.test(email.trim())

/** Safe internal redirect — only allow relative /learner paths. */
export const resolveLearnerReturnPath = (
  candidate: string | null | undefined,
  fallback: string
): string => {
  if (!candidate) return fallback
  if (!candidate.startsWith("/learner")) return fallback
  if (candidate.startsWith("//")) return fallback
  if (candidate.includes("://")) return fallback
  // Never bounce an authenticated user back onto the login screen.
  if (
    candidate === "/learner/login" ||
    candidate.startsWith("/learner/login?") ||
    candidate.startsWith("/learner/login/")
  ) {
    return fallback
  }
  return candidate
}
